import { render, staticRenderFns } from "./showAside.vue?vue&type=template&id=06a759e8&scoped=true"
import script from "./showAside.vue?vue&type=script&lang=js"
export * from "./showAside.vue?vue&type=script&lang=js"
import style0 from "./showAside.vue?vue&type=style&index=0&id=06a759e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a759e8",
  null
  
)

export default component.exports